import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DoubleArrow from "../../assets/double.png"
import { useNavigate, useParams } from "react-router-dom";
export default function SwipeToVend({fetchCode}) {
  const navigate=useNavigate()
  const [swiped, setSwiped] = useState(false);
  const [completed, setCompleted] = useState(false);
  const controls = useAnimation();

  const {orderId}=useParams()
  const handleSwipe = async () => {
    setSwiped(true);
    setCompleted(true); // change icon -> image
    console.log("✅ Swipe action triggered!");
    fetchCode()
    //navigate(`/vendOrder/number/${orderId}`)
      setTimeout(() => {
    controls.start({ x: 0 });
  }, 1000);

  }

  return (
    <Box
      sx={{
       
        width: "100%",
        display: "flex",
      justifyContent: "center",
      position: "fixed",
    bottom: "20px"
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "90%",
          height: 60,
          borderRadius: "12px",
          backgroundColor: "rgba(0, 177, 118, 1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        <Typography
          variant="h6"
          sx={{ color: "white", fontWeight: 600, zIndex: 1 }}
        >
          Swipe To Vend
        </Typography>

        {/* Swiper Handle */}
        <motion.div
          drag="x"
          dragConstraints={{ left: 0, right:300}}
          animate={controls}
          onDragEnd={(e, info) => {
            if (info.offset.x > 0.9 * 300) {
              // 90% threshold
              handleSwipe();
            } else {
              controls.start({ x: 0 });
            }
          }}
          style={{
            position: "absolute",
            left: 5,
            width: 60,
            height: "90%",
            background: "#fff",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "grab",
          }}
        >
          {DoubleArrow ? (
            <img
              src={DoubleArrow} // <-- replace with your image path
              alt="done"
              style={{ width: 28, height: 28 }}
            />
          ) : (
            <ArrowForwardIosIcon sx={{ color: "#00A86B", fontSize: 28 }} />
          )}
        </motion.div>
      </Box>
    </Box>
  );
}
